import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { OrganizationAdminService } from '../../services/organization-admin.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Organization } from '../../models/organization';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';

import { OrgCreateComponent } from '../org-create/org-create.component';

import { PAGE_SIZE_OPTIONS, PAGE_LENGTH, ITEMS_PER_PAGE, CURRENT_PAGE } from '../../../../shared/constants/pagination.constants';
import { MatSort } from '@angular/material/sort';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, Validators } from '@angular/forms';
import { delay } from 'rxjs/operators';
import { LoaderService } from 'src/app/auth/services/loader.service';

const dialogConfig= new MatDialogConfig();
dialogConfig.disableClose = true;
dialogConfig.autoFocus = true;
// dialogConfig.maxHeight ="500px";

@Component({
  selector: 'app-org-details',
  templateUrl: './org-details.component.html',
  styleUrls: ['./org-details.component.css']
})
export class OrgDetailsComponent implements OnInit,AfterViewInit {

  @ViewChild('paginator', {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;


  public organizationsDisplayedColumns: string[] = ['name','int_plan_id', 'added_date'];

  public organizationsDataSource:any;

  public PAGE_SIZE_OPTIONS_DATA:number[] = PAGE_SIZE_OPTIONS;

  public page_length:number = PAGE_LENGTH;

  public items_per_page:number = ITEMS_PER_PAGE;

  public current_page:number = CURRENT_PAGE;

  public advanceSearchCtrl = new FormControl('',Validators.required);


  constructor(
    private organizationService:OrganizationAdminService,
    private dialog:MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private loaderService:LoaderService
    ) { }

  ngOnInit(): void {
     this.loadIcon();
     this.getOrganizations();
     this.advancerSeach();
  }

  ngAfterViewInit(){
    if(this.organizationsDataSource != undefined){
      this.organizationsDataSource.paginator = this.paginator;
      // this.organizationsDataSource.sort = this.sort;
    }
  }

  loadIcon(){
    this.matIconRegistry.addSvgIcon(
      "filter",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/SVG/filter.svg")
    );
  }

  addFilterParameters(){
    let filterParams = {};
    filterParams['page']=this.current_page;
    filterParams["per-page"]=this.items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }

  getOrganizations(){
    this.loaderService.isTableLoding.next(true);

    let filterParams = this.addFilterParameters();

    let searchParams = this.advanceSearchCtrl.value; 

    if( searchParams != '' && searchParams.length >= 3){
      filterParams['filter[name][like]'] = searchParams.trim();
    }

    // console.log(filterParams);
    this.organizationService.getOrganizations(filterParams).subscribe(
      (res) => {
        this.loaderService.isTableLoding.next(false);
        this.page_length = res.headers.get('X-Pagination-Total-Count');
        this.current_page = res.headers.get('X-Pagination-current-page');
        this.items_per_page = res.headers.get('X-Pagination-Per-Page');
        this.organizationsDataSource = new MatTableDataSource<Organization>(res.body);
      },
      (err)=>{
        console.log(err);
      }
    );
  }

  handlePage(e?: any):void {
    if(e){
      this.current_page = e.pageIndex+1;
      this.items_per_page = e.pageSize;
      this.page_length = e.length;
    }
    this.getOrganizations();
  }

  createOrganization():void{
    dialogConfig.width ="40%";
    this.dialog.open(OrgCreateComponent,dialogConfig);

    // UPDATE CONTACT DETAILS AFTER CREATING THE CONTACT
    this.dialog.afterAllClosed.subscribe(e=>{
       this.getOrganizations();
    });
  }

  advancerSeach(){
    this.advanceSearchCtrl.valueChanges
    .pipe(
      delay(300),
    )
    .subscribe(val=> {
        this.getOrganizations();
   });
}

}


